import {TrackDTO} from '../types';

export class QueueManager {
    private items: TrackDTO[] = [];
    private index = 0;

    get currentIndex(): number {
        return this.index;
    }

    set currentIndex(value: number) {
        this.index = value;
    }

    get size(): number {
        return this.items.length;
    }

    get current(): TrackDTO | undefined {
        return this.items[this.index];
    }

    get list(): TrackDTO[] {
        return [...this.items];
    }

    replace(track: TrackDTO, queue: TrackDTO[]): void {
        this.items = [...queue];
        const found = queue.findIndex(t => t.id === track.id);
        this.index = found >= 0 ? found : 0;
    }

    nextIndex(): number | null {
        if (this.items.length === 0) return null;
        return (this.index + 1) % this.items.length;
    }

    previousIndex(): number | null {
        if (this.items.length === 0) return null;
        return (this.index + this.items.length - 1) % this.items.length;
    }
}
